module.exports = __webpack_public_path__ + "img/cbia_logo_icon.4c7ff076.png";